<template>
    <div id="m-inbox" style="height: 100%">
        <v-overlay v-if="loading">
            <v-progress-circular indeterminate color="primary"/>
        </v-overlay>
        <v-alert type="error" width="20%" v-else-if="message" style="margin-top: 50px;margin-left: 50%;left: -10%;">
            {{ message }}
        </v-alert>
        <v-card v-else elevation="0">
            <v-card-actions v-if="usersCountPerApp.length != 0" class="ma-0 pa-0 mx-2 my-2">
                <v-card outlined width="100%" class="ma-0 pa-0">
                    <v-card-actions class="ma-0 pa-0">
                        <v-data-table
                                style="width: 100%;"
                                fixed-header
                                :headers="header"
                                :items="usersCountPerApp"
                                hide-default-footer
                                disable-pagination>
                            <template v-slot:item.actions="{ item }">
                                <v-btn icon
                                       color="red"
                                       class="mr-0"
                                       @click="onPressDelete(item)">
                                    <v-icon size="22">mdi-delete</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-card-actions>
                </v-card>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

import {InfoStoreUtils} from "@/modules/minfo/database/InfoStoreUtils";

export default {
    name: "i-users-by-app-version",
    components: {},
    data: () => ({
        header: [
            {text: 'Version', sortable: true, value: 'ver', class: "white blue--text", color: "red"},
            {text: 'Users', sortable: true, value: 'count', class: "white blue--text", color: "red"},
            {text: 'Actions', sortable: false, value: 'actions', class: "white blue--text", width:'10%', align:'end'}
        ],
        loading: false,
        message: "",
    }),
    computed:{
        usersCountPerApp(){
            return InfoStoreUtils.getUsersCountPerApp()
        }
    },
    created() {
        this.getUsersByAppVersion()
    },
    methods: {
        reloadData(){
            this.getUsersByAppVersion()
        },
        //getMyUserUid(){
            //return PermissionsStoreUtils.getMyUserUid();
        //},
        //ifCanDeleteInfo(){
            //return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.INFO_TAB.subpermissions.INFO_TAB_DELETE.id)
        //},
        onPressDelete(item){
            this.$confirm("Are you sure?")
                .then(() => {
                    InfoStoreUtils.removeUsersCountPerApp([item.ver])
                    .then(() => {
                        this.$notify({title: 'Succes!', text: "", type: "succes"});
                    })
                    .catch((error) => {
                        this.$notify({title: 'Fail!', text: error, type: "error"});
                    })
                }).catch(() => {})
        },
        getUsersByAppVersion(){
            this.loading = true
            InfoStoreUtils.fethUsersCountPerApp()
            .then(() => {
                this.loading = false
                this.$notify({title: 'Succes!', text: "", type: "succes"});
            })
            .catch((error) => {
                this.loading = false
                this.$notify({title: 'Fail!', text: error, type: "error"});
            })
        },
    },
}
</script>

<style scoped>
</style>